export class StyleModel {
    constructor(obj) {
        this.dept = obj?.dept ?? '';
        this.deptCode = obj?.deptCode ?? '';
        this.distributionDate = obj?.distributionDate ?? '';
        this.name = obj?.name ?? '';
        this.otbDate = obj?.otbDate ?? '';
        this.styleNumber = obj?.styleNumber ?? '';
        this.assets = [];
        
        if (obj) {
            Object.assign(this, obj);
        }
    }
}

export const StyleEventType = {
    SAMPLE_BUILD_OUTFIT: 'sampleBuildOutfit',
    SAMPLE_EDIT: 'sampleEdit',
    SAMPLE_ADD: 'sampleAdd',
    SAMPLE_VIEW: 'sampleView',
    SAMPLE_DELETE: 'sampleDelete',
    SAMPLE_DOWNLOAD: 'sampleDownload',
    SAMPLE_ASSIGN_CAPTURES: 'sampleAssignCaptures',
    SAMPLE_SHOW_SESSION: 'sampleShowSession',
    SAMPLE_DISTRIBUTE: 'sampleDistribute',
};

export const StyleStatusTypes = {
    ARCHIVE: 'inactive',
    ACTIVE: 'active',
};

// this model is for the session samples
export const StyleFilterModel = {
    keyword: '',
    brands: [],
    departments: [],
    location: [],
    status: {
        sampleCount: '',
        photographyCount: '',
        taskCount: '',
        taskCompletedCount: '',
        hasSession:'',
    },
    colour: '',
    sessions: [],
    pageIndex:0,
};
